// extracted by mini-css-extract-plugin
export default {"card":"ContactMethodCard_card__W1G5A","title":"ContactMethodCard_title__G5J3W","detail":"ContactMethodCard_detail__jAKcv","note":"ContactMethodCard_note__pCizh"};